
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.75 28V0h28v28z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M6.764 6.014h4.564v4.564H6.764V6.014zM4.483 12.86h9.126V3.733H4.483v9.126zm2.281 4.562h4.564v4.564H6.764v-4.564zm-2.281 6.845h9.126v-9.126H4.483v9.126zm18.253-13.689h-4.564V6.014h4.564v4.564zM15.89 3.733v9.126h9.126V3.733H15.89zm9.124 18.248h-2.283v2.283h2.283zm-6.839-6.839h-2.283v2.283h2.283zm2.283 2.283h-2.283v2.283h2.283z"}}),_c('path',{attrs:{"d":"M18.175 19.708h-2.283v2.273h2.283zm2.283 2.273h-2.283v2.283h2.283zm2.273-2.273h-2.273v2.273h2.273zm0-4.566h-2.273v2.283h2.273z"}}),_c('path',{attrs:{"d":"M25.014 17.425h-2.283v2.283h2.283z"}})])])])
          )
        }
      }
    